import { CharacterGridContainer } from '../CharacterGridContainer';
import { CharacterView } from '../CharacterView';
import { Character } from '../models';

import styles from './CharacterPreview.module.css';

type Props = {
  character: Character | null;
  size?: number;
  borderRadius?: number | string;
  animatedTo?: number;
  getColor: (
    index: number,
    component: number,
    isShadow: boolean,
  ) => string | undefined;
  onAnimationComplete?: (index: number) => void;
};

export const CharacterPreview = (props: Props) => {
  const {
    character,
    size = 300,
    borderRadius,
    animatedTo,
    getColor,
    onAnimationComplete,
  } = props;
  return (
    <div className={styles.container} style={{ width: size, height: size }}>
      <div className={styles.characterGrid}>
        <CharacterGridContainer size={size} borderRadius={borderRadius} />
      </div>

      <div className={styles.characterView}>
        <CharacterView
          character={character}
          size={size}
          animatedTo={animatedTo}
          getColor={getColor}
          onAnimationComplete={onAnimationComplete}
        />
      </div>
    </div>
  );
};
